import { render, staticRenderFns } from "./Tagline.vue?vue&type=template&id=77487fc6&scoped=true"
import script from "./Tagline.vue?vue&type=script&lang=js"
export * from "./Tagline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77487fc6",
  null
  
)

export default component.exports